// @ts-nocheck
import { useCallback, useState } from 'react';
import { useTheme } from '@mui/material';
import {
  useThemeAppearanceQuery,
  useUpdateThemeMutation,
  useSaveUserThemeTypeMutation,
} from '../api/themeAppearanceQueries';

export const THEME_STORAGE_KEY = 'theme';

export const readThemeFromLocalStorage = () => {
  try {
    return JSON.parse(localStorage.getItem(THEME_STORAGE_KEY) || '{}');
  } catch (_error) {
    return {};
  }
};

export const saveThemeInLocalStorage = (theme) => {
  localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(theme || {}));
};

export default function useThemeAppearance() {
  const defaultTheme = useTheme();

  const [currentSavedTheme, setCurrentSavedThemeState] = useState(() =>
    readThemeFromLocalStorage()
  );

  const { execute: getCurrentThemeQuery } = useThemeAppearanceQuery({
    options: { loader: false, enabled: false },
  });

  const { mutateAsync: updateThemeMutation } = useUpdateThemeMutation();
  const { mutateAsync: saveUserThemeTypeMutation } =
    useSaveUserThemeTypeMutation();

  const setCurrentSavedTheme = useCallback((theme) => {
    saveThemeInLocalStorage(theme);
    setCurrentSavedThemeState(theme || {});
  }, []);

  const getCurrentTheme = useCallback(
    (params) => {
      return getCurrentThemeQuery({ params }).then((data) => {
        if (data) {
          setCurrentSavedTheme(data);
        }
        return { data };
      });
    },
    [getCurrentThemeQuery, setCurrentSavedTheme]
  );

  const saveTheme = useCallback(
    (body) => {
      return updateThemeMutation(body).then((res) => {
        saveThemeInLocalStorage(body);
        if (body?.theme_type) {
          getCurrentTheme({ theme: body?.theme_type });
        }
        return res;
      });
    },
    [updateThemeMutation, getCurrentTheme]
  );

  const saveUserThemeType = useCallback(
    (body) => {
      return saveUserThemeTypeMutation(body);
    },
    [saveUserThemeTypeMutation]
  );

  return {
    getCurrentTheme,
    currentSavedTheme,
    saveTheme,
    defaultTheme,
    setCurrentSavedTheme,
    saveUserThemeType,
  };
}
